export default {"src":"/_next/static/media/close-with-border.00cdf907.svg","height":18,"width":18};